import type { User } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { gql } from '@apollo/client';
import { getTenantList, getUserList } from '#/graphql/queries';
import { rolesList } from '../../utils/constants';

const columns: ColumnProps<User>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'name',
    caption: 'User Name',
    visible: true,
    openOnClick: true,
    dataType: 'string',
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'role',
    caption: 'Role',
    visible: true,
    openOnClick: false,
    dataType: 'string',
    lookup: {
      dataSource: rolesList,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  {
    dataField: 'updatedAt',
    caption: 'Sync Date',
    visible: true,
    openOnClick: false,
    dataType: 'date',
  },
  {
    dataField: 'groups',
    caption: 'Organizations',
    visible: true,
    openOnClick: false,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'address',
    caption: 'Residential Address',
    visible: true,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'email',
    caption: 'Email',
    visible: false,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'phone',
    caption: 'Phone',
    visible: false,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'location',
    caption: 'Location',
    visible: false,
    openOnClick: false,
    dataType: 'string',
  },
  {
    dataField: 'createdByUser.name',
    caption: 'Created By',
    visible: false,
    openOnClick: false,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getUserList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'createdAt',
    caption: 'Created At',
    visible: false,
    openOnClick: false,
    dataType: 'date',
  },
  {
    dataField: 'updatedByUser.name',
    caption: 'Updated By',
    visible: false,
    openOnClick: false,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getUserList),
      displayExpr: 'name',
    },
  },
];

export default columns;
